module.exports = __webpack_public_path__ + "img/28-r.8322dd15.png";